import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../../../utils/globals/data'
import { getISOCurrencyMain } from '../../../../utils/reducers/getters'
import { roundNumberByParams, preciseDecimalSum } from '@teinor/erp/prices'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { getCurrencySymbol } from '../../../../utils/globals/price'
import './quotestatusprogressbar.sass'
import TwinTrans from '../../../TwinTrans'
import { QuoteOrderStatusInversed } from '@teinor/erp/types/company/order/quote/quoteOrder'
import { displayFormatedNumber } from '../../../../utils/globals/numbers'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'

interface DSBQuoteStatusProgressBarProps extends DSBQuoteStatusProgressBarLogicProps {
    title?: string
}
const DSBQuoteStatusProgressBar = ({ title, end_date, start_date }: DSBQuoteStatusProgressBarProps) => {
    const mainCurrency = getISOCurrencyMain()
    const currencySymbol = getCurrencySymbol(mainCurrency)
    const { quoteStatus } = useDSBQuoteStatusProgressBarLogic({ end_date, start_date })
    const renderHeader: JSX.Element[] = []
    const renderThis: JSX.Element[] = []
    for (const key in quoteStatus) {
        const item = quoteStatus[key]
        renderHeader.push(
            <div className='quote_progress_bar_header_box' key={key}>
                <div className='flex gap-10 items-center quote_progress_bar_header_inner_legend'>
                    <div className={'quote_progress_bar_header_inner_' + key}></div>
                    <div className={'quote_progress_bar_header_inner_status_name'}>{`${item.name}  (${item.totalStatus})`}</div>
                </div>
                <div className='quote_progress_bar_header_inner_amount'>{displayFormatedNumber(item.totalImport) + ' ' + currencySymbol}</div>
            </div>
        )
        renderThis.push(<div className={'quote_progress_bar_' + key} key={key} style={{ width:  item.totalStatusPer + '%'}}></div>)
    }
    if (renderHeader.length === 0) {
        renderHeader.push(<div key={'noData'}><TwinTrans transKey={'noData'} >No hay datos</TwinTrans></div>)
    }
    return (
        <div className='flex flex-col gap-20 flex-auto h-1'>
            <h3>{title}</h3>
            <div className='flex gap-x-30'>
                {renderHeader}
            </div>
            <div className='quote_progress_bar'>
                {renderThis}
            </div>
        </div>
    )
}

interface DSBQuoteStatusProgressBarLogicProps {
    start_date: Date
    end_date: Date
}

const useDSBQuoteStatusProgressBarLogic = ({ end_date, start_date }: DSBQuoteStatusProgressBarLogicProps) => {
    const [quoteStatus, setQuoteStatus] = useState<TwinDictionary>({})
    const {t} = useTwinTranslation()
    const myStatus = JSON.stringify({
        [QuoteOrderStatusInversed['creating']]: t('draft', 'Borrador'),
        [QuoteOrderStatusInversed['waitingResponse']]: t('pending', 'Pendiente'),
        [QuoteOrderStatusInversed['sent']]: t('sent', 'Enviado'),
        [QuoteOrderStatusInversed['accepted']]: t('accepted', 'Aceptado'),
        [QuoteOrderStatusInversed['denied']]: t('cancelled', 'Cancelado'),
    })

    const getData = useCallback(async () => {
        const myStatusParsed = JSON.parse(myStatus)
        const result = await twinFetchPostJSON('/api/app/order/quote/getAllQuoteOrdersForStats', {
            attributes: ['total_without_vat', 'status'],
            where: { 'QuoteOrder.createdAt': { '$betweenN': [start_date, end_date] }, is_last: true }
        })
        const statusDict: TwinDictionary = {}
        let myTotal = 0
        if (result) {
            for (const element of result) {
                const myStatus = element.status !== QuoteOrderStatusInversed['processed'] ? element.status : QuoteOrderStatusInversed['accepted']
                myTotal += 1
                if (!statusDict[myStatus]) {
                    statusDict[myStatus] = {
                        totalStatus: 0,
                        totalImport: 0,
                        name: myStatusParsed[parseInt(myStatus)]
                    }
                }
                statusDict[myStatus].totalStatus += 1
                statusDict[myStatus].totalImport = parseFloat(roundNumberByParams(preciseDecimalSum(statusDict[myStatus].totalImport, parseFloat(element.total_without_vat))).toFixed(2))
            }

            for (const key in statusDict) {
                const element = statusDict[key]
                statusDict[key] = {
                    totalStatusPer: (element.totalStatus / myTotal) * 100,
                    totalImport: element.totalImport,
                    totalStatus: element.totalStatus,
                    name: element.name
                }
            }

            setQuoteStatus(statusDict)
        }
    }, [setQuoteStatus, end_date, start_date, myStatus])

    useEffect(() => {
        getData()
    }, [getData])

    return { quoteStatus }
}


export default DSBQuoteStatusProgressBar